import parse from "html-react-parser"
import AnimatedComponent from "../AnimateComponent";


const LandingServices = ({ data }) => {
    return (
        <div id="services" className="w-full flex justify-between bg-landingService bg-cover bg-no-repeat bg-center  ">
            <div  className="2xl:container flex flex-col gap-y-16 mx-auto w-full md:px-14 pt-20  pb-20  lg:px-20 px-6">
                              <AnimatedComponent delay={0.4}>
 <div className="flex flex-col items-center gap-y-8 w-full text-center">
                    <h2 className="text-white text-28 sm:text-32 md:text-40 font-bold sm:w-[80%]">{data.title}</h2>
                    <p className="text-16 sm:text-18 text-white opacity-75 font-regular sm:w-[80%]">{parse(data.desc)}</p>
                </div>
                            </AnimatedComponent>
                              <AnimatedComponent delay={0.5}>

                <div className="flex flex-col max-lg:items-center lg:flex-row w-full gap-6">
                    <div className="flex flex-col gap-6 bg-[#15162A] p-10 w-full sm:w-[90%] md:w-[60%] lg:w-[35%]">
                        <div className="flex flex-col gap-8 text-left  ">
                            <h3 className="text-20 sm:text-24 text-white  font-semibold">{data.authors.title}</h3>
                            <div className="flex flex-col gap-4">
                                {data.authors.content.map((para, ind) => (
                                    <p key={ind} className=" text-14 sm:text-16 text-left font-regular text-white opacity-75 flex gap-4 ">
                                        <img
                                            src={process.env.PUBLIC_URL + "/images/landing-page/right-arrow.svg"}
                                            alt="icon"
                                        />
                                        <span>{para}</span>
                                    </p>
                                ))}
                            </div>
                        </div>
                        <p className="border-b-[1px] border-serviceborder my-[10px] "></p>
                        <div className="flex flex-col gap-8 text-left ">
                            <h3 className="text-20 sm:text-24 text-white  font-semibold">{data.Editors.title}</h3>
                            <div className="flex flex-col gap-4">
                                {data.Editors.content.map((para, ind) => (
                                    <p key={ind} className=" text-14 sm:text-16 text-left font-regular text-white opacity-75 flex gap-4 ">
                                        <img
                                            src={process.env.PUBLIC_URL + "/images/landing-page/right-arrow.svg"}
                                            alt="icon"
                                        />
                                        <span>{para}</span>
                                    </p>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className=" max-sm:px-5 p-10 border w-full sm:w-[90%] md:w-[90%] lg:w-[65%] border-white border-[rgba(255, 255, 255, 0.5    )] text-left">
                        <h3 className="text-24 sm:text-28 text-white font-semibold">{data.report.title}</h3>
                        <p className="border-b-[1px] border-white my-5 w-[20%] sm:w-[15%] md:w-[15%] lg:w-[10%]"></p>
                        <div className="grid max-md:grid-cols-1 grid-cols-2 gap-8">
                            {
                                data.report.content.map((item,i)=>(
                                    <div className="flex flex-col gap-5 text-left">
                                        <h4 className="text-18 sm:text-20 text-white font-semibold">{item.heading}</h4>
                                        <p className="text-14 sm:text-16 text-lightwhite  font-regular">{item.para}</p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                </div>
                            </AnimatedComponent>

            </div>
        </div>
    )
}
export default LandingServices;